export const OTEL_EXPORTER_OTLP_ENDPOINT = "http://ingest-signoz.neurotaskai.com:4318";
export const OTEL_SERVICE_NAME = process.env.NODE_ENV === 'development' ? 'interview-frontend-dev' : 'interview-frontend-prod';
